import {
  Autocomplete,
  Button,
  CircularProgress,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { Form, Formik, FormikProps } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import GayrimenkulBulPopUp from "../../../components/OB/PopUp";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import BinaBasvuruSave from "../../../apis/OB/SaveApi/BinaBasvuruSave";
import { binaBasvuruValidationSchema } from "../../../validations/EmlakBasvuru";
import KullanimSekliListeAPI from "../../../apis/OB/Get/KullanimSekliListeAPI";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import InsaatSinifiAPI from "../../../apis/OB/Get/InsaatSinifiAPI";
import InsaatTuruAPI from "../../../apis/OB/Get/InsaatTuruAPI";
import CustomTextField from "../../../components/OB/required-text-field";
import CustomDatePicker from "../../../components/OB/required-datepicker";
import SessionStorageService from "../../../services/StorageService";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import DysAPI from "../../../apis/DysAPI";
import Recaptcha from "../../../components/Recaptcha";
import { useFormConfig } from "../../../hooks/useFormConfig";
import ConfigurableField from "../../../components/OB/ConfigurableField";

const BinaBasvuru = () => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  const [open, setOpen] = useState(false);
  const openPopup = () => {
    setOpen(true);
  };
  const [kullanimSekliKoduList, setkullanimSekliKoduList] = useState<any[]>([]);
  const [insaatTuruKoduList, setInsaatTuruKoduList] = useState<any[]>([]);
  const [insaatSinifiKoduList, setInsaatSinifiKoduList] = useState<any[]>([]);
  useEffect(() => {
    KullanimSekliListeAPI.getKullanimSekliListe(undefined)
      .then((response) => {
        console.log(response.data);
        setkullanimSekliKoduList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    InsaatSinifiAPI.getInsaatSinifiListe(undefined).then((response) => {
      setInsaatSinifiKoduList(response.data);
      console.log(response.data);
    });
  }, []);

  useEffect(() => {
    InsaatTuruAPI.getInsaatTuruListe(undefined).then((response) => {
      setInsaatTuruKoduList(response.data);
      console.log(response.data);
    });
  }, []);
  const { mahalleListe } = useContext(ConstantAPISContext);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupAciklama, setPopupAciklama] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);
  const user = SessionStorageService.getUserInfo()

  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupAciklama("");
  };
  const closePopup = () => {
    setOpen(false);
  };
  const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<number | null>(
    null
  );
  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  // Dinamik Form Konfigurasyon Hook
  const { config, isFieldVisible, getFieldLabel, buildValidationSchema } = useFormConfig('BINA_BASVURU');

  const handleDecimalChange = (fieldName: string, value: string, setFieldValue: any) => {
    const formatted = value
      .replace(/[^0-9.]/g, "") // Rakamlar ve noktalar dışındaki karakterleri kaldır
      .replace(/^0+([1-9])/, "$1") // Başındaki gereksiz sıfırları kaldır
      .replace(/^0+\./, "0.") // 00. -> 0. düzelt
      .replace(/^[.]/, "0.") // Nokta ile başlarsa önüne 0 ekle
      .replace(/\./g, (match: any, i: any, original: any) =>
        i === original.indexOf(".") ? "." : ""
      ) // Yalnızca ilk noktayı bırak, diğerlerini sil
      .replace(/(\.\d{2})\d+/, "$1") // Ondalık noktadan sonra sadece iki basamak olacak şekilde sınırla
      .replace(/^-/, ""); // Negatif işareti kaldır

    setFieldValue(fieldName, formatted);
  };

  const handleDecimalBlur = (fieldName: string, value: string, setFieldValue: any) => {
    if (value && !value.includes(".")) {
      setFieldValue(fieldName, `${value}.00`);
    } else if (value && value.endsWith(".")) {
      setFieldValue(fieldName, `${value}00`);
    } else if (value && value.split(".")[1]?.length === 1) {
      setFieldValue(fieldName, `${value}0`);
    }
  };

  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };
  useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: 1 })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });


        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);
  const [caddeListe, setCaddeListe] = useState<any[]>([]);
  useEffect(() => {
    if (selectedMahalleKodu) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
        .then((res) => {
          setCaddeListe(res.data);
        })
        .catch(() => {
          console.log("hata");
        })
        .finally(() => { });
    } else {
      setCaddeListe([]);
    }
  }, [selectedMahalleKodu]);
  return (
    <Formik
      validateOnMount={true}
      validationSchema={buildValidationSchema(binaBasvuruValidationSchema)}
      initialValues={{
        basvuruTuruId: 1,
        sicilKodu:user?.sicilKodu,
        mahalleKodu: null,
        caddeSokakKodu: null,
        kapiNo: "",
        altKapiNo: "",
        kaloriferliMi: null,
        asansorluMu: null,
        daireNo: "",
        altDaireNo: "",
        siteApartmanAdi: "",
        blokNo: "",
        katNo: "",
        pafta: "",
        ada: "",
        parsel: "",
        tapuBlokNo: "",
        tapuKatNo: "",
        tapuCiltNo: "",
        tapuSayfaNo: "",
        tapuYevmiyeNo: "",
        tapuBagimsizNo: "",
        arsaYuzolcumu: "",
        arsaHisse: "",
        arsaOran: "",
        arsa2Hisse: "1.00",
        arsa2Oran: "1.00",
        hisseyeDusenArsaYuzolcumu: "",
        binaYuzolcumu: "",
        binaHisse: "",
        binaOran: "",
        bina2Hisse: "1.00",
        bina2Oran: "1.00",
        hisseyeDusenBinaYuzolcumu: "",
        pismanlikIndirimi: "",
        insaatTuruKodu: "",
        insaatSinifiKodu: "",
        kullanimSekliKodu: "",
        tapuYevmiyeTarihi: null,
        insaatBitisTarihi: null,
        edinmeTarihi: null,
        aciklama: "",
      }}
      onSubmit={async (values: any, { resetForm }) => {
        const missingDocuments = documents
          .filter(doc => doc.isRequired) // zorunlu belgeler
          .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

        if (missingDocuments.length > 0) {
          const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
          toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
          documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
          return; // başvuru burada durur
        }

        // reCAPTCHA’yı tetikle
        const token = await recaptchaRef.current?.handleSubmit();
        if (!token) {
          toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
          return;
        }

        setLoadingSubmit(true);
        const transformedValues = {
          ...values,
          basvuruTuruId: safelyParseNumber(values.basvuruTuruId),
          mahalleKodu: safelyParseNumber(values.mahalleKodu),
          caddeSokakKodu: safelyParseNumber(values.caddeSokakKodu),
          sicilKodu: safelyParseNumber(values.sicilKodu) || 0,
          daireNo: values.daireNo != "" ? safelyParseNumber(values.daireNo) : null,
          ada: values.ada != "" ? safelyParseNumber(values.ada) : null,
          parsel: values.parsel != "" ? safelyParseNumber(values.parsel) : null,
          tapuCiltNo: values.tapuCiltNo != "" ? safelyParseNumber(values.tapuCiltNo) : null,
          tapuSayfaNo: values.tapuSayfaNo != "" ? safelyParseNumber(values.tapuSayfaNo) : null,
          arsaYuzolcumu: safelyParseNumber(values.arsaYuzolcumu),
          arsaHisse: safelyParseNumber(values.arsaHisse),
          arsaOran: safelyParseNumber(values.arsaOran),
          arsa2Hisse: safelyParseNumber(values.arsa2Hisse),
          arsa2Oran: safelyParseNumber(values.arsa2Oran),
          binaYuzolcumu: safelyParseNumber(values.binaYuzolcumu),
          binaHisse: safelyParseNumber(values.binaHisse),
          binaOran: safelyParseNumber(values.binaOran),
          bina2Hisse: safelyParseNumber(values.bina2Hisse),
          bina2Oran: safelyParseNumber(values.bina2Oran),
          insaatTuruKodu: values.insaatTuruKodu != "" ? safelyParseNumber(values.insaatTuruKodu) : null,
          insaatSinifiKodu: values.insaatSinifiKodu != "" ? safelyParseNumber(values.insaatSinifiKodu) : null,
          kullanimSekliKodu: safelyParseNumber(values.kullanimSekliKodu),
          tapuYevmiyeTarihi: values.tapuYevmiyeTarihi != null ? dayjs(values.tapuYevmiyeTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD") : null,
          insaatBitisTarihi: values.insaatBitisTarihi != null ? dayjs(values.insaatBitisTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD") : null,
          edinmeTarihi: values.edinmeTarihi != null ? dayjs(values.edinmeTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD") : null,
          captchaToken: token
        };
        {/* const formattedDate = dayjs(values.dogumTarihi)  T09:40:46.292Z
          .tz("Europe/Istanbul")
          .format("YYYY-MM-DD");*/}

        BinaBasvuruSave.saveBinaBasvuruSave(transformedValues)
          .then(async (res) => {
            console.log(res);
            if (res.data.sonuc === 0) {
              let basvuruNo = res.data.basvuruNo;

              // DYS API'yi çağır 
              try {
                // Sadece dosyası olanları al
                const filesToSend = documents.filter((doc: any) => !!doc.file);

                if (filesToSend.length > 0) {
                  const formData = new FormData();

                  filesToSend.forEach((doc: any) => {
                    formData.append("files", doc.file, doc.file.name);
                    formData.append("rfObBasvuruTanimBelge", String(doc.id));
                  });

                  formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                  formData.append("basvuruId", String(basvuruNo));
                  formData.append("folderName", "AKOS");
                  formData.append("kurumId", "1");
                  formData.append("versionable", "1");

                  const response = await DysAPI.upload(formData);
                  toast.warning(response.message);
                } else {
                  // Burada return yok — sadece DYS çağrısını atlıyoruz.
                  
                }
              } catch (error: any) {
                toast.error("DYS upload hazırlama hatası:", error);
              }

              setPopupAciklama("İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " + basvuruNo);
              resetForm();
              setKayitBasarili(true);
              setDocuments((prevDocs: any[]) =>
                prevDocs.map((doc) => ({
                  ...doc,
                  file: null,
                  fileName: "",
                }))
              );
            } else {
              setPopupAciklama(res.data.sonucAciklama);
            }
          })
          .catch((err) => {
            setPopupAciklama(
              "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
            );
          })
          .finally(() => {
            setIsPopupVisible(true);
            recaptchaRef.current?.reset();
            setLoadingSubmit(false);
          });
      }}
    >
      {(formikProps) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (
            formikProps.values.arsaOran !== "" &&
            formikProps.values.arsaHisse !== "" &&
            formikProps.values.arsaYuzolcumu !== ""
          ) {
            let result =
              Number(formikProps.values.arsaYuzolcumu) *
              (Number(formikProps.values.arsaHisse) /
                Number(formikProps.values.arsaOran))
              * (Number(formikProps.values.arsa2Hisse || 1.00) /
                Number(formikProps.values.arsa2Oran || 1.00));
            formikProps.setFieldValue(
              "hisseyeDusenArsaYuzolcumu",
              result.toString()
            );
          }
          if (
            formikProps.values.binaOran !== "" &&
            formikProps.values.binaHisse !== "" &&
            formikProps.values.binaYuzolcumu !== ""
          ) {
            let result =
              Number(formikProps.values.binaYuzolcumu) *
              (Number(formikProps.values.binaHisse) /
                Number(formikProps.values.binaOran)) *
              (Number(formikProps.values.bina2Hisse || 1.00) /
                Number(formikProps.values.bina2Oran || 1.00));
            formikProps.setFieldValue(
              "hisseyeDusenBinaYuzolcumu",
              result.toString()
            );
          }
        }, [formikProps.values.arsaOran, formikProps.values.arsaHisse, formikProps.values.arsaYuzolcumu, formikProps.values.binaOran, formikProps.values.binaHisse, formikProps.values.binaYuzolcumu, formikProps.values.arsa2Hisse, formikProps.values.arsa2Oran, formikProps.values.bina2Hisse, formikProps.values.bina2Oran]);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showToastIfErrorsExist = () => {
          if (Object.keys(formikProps.errors).length > 0) {
            focusFirstErrorField();
            toast.error("Lütfen zorunlu alanları doldurun!");

          }
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formRefs = useRef<any>({});
        const focusFirstErrorField = () => {
          const errorKeys = Object.keys(formikProps.errors);
          if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0];
            console.log(errorKeys[0])
            const element = document.querySelector(`[name="${firstErrorKey}"]`);
            if (element) {
              (element as HTMLElement).focus();
            }
          }
        };
        return (
          <Form onSubmit={formikProps.handleSubmit}>
            <div className="row">
              <div className="col-12 mb-2">
                <div className="d-flex justify-content-between align-self-stretch">
                  <Button onClick={openPopup} type="button" color="warning" >
                    Gayrimenkul Bul
                  </Button>
                  <Button

                    type="button"

                    color="secondary"

                    onClick={() => {
                      formikProps.resetForm({ values: formikProps.initialValues });
                      setDocuments((prevDocs: any[]) =>
                        prevDocs.map((doc) => ({
                          ...doc,
                          file: null,
                          fileName: "",
                        }))
                      );
                    }}
                  >

                    Temizle
                  </Button>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">

                      <ConfigurableField fieldName="mahalleKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="mahalleKodu"
                          fullWidth
                          className="mb-3"
                          select
                          label={getFieldLabel("mahalleKodu", "Mahalle *")}
                          size="small"
                          error={
                            formikProps.errors.mahalleKodu &&
                              formikProps.touched.mahalleKodu
                              ? true
                              : false
                          }
                          value={formikProps.values.mahalleKodu}
                          onChange={(value: any) => {
                            formikProps.setFieldValue(
                              "mahalleKodu",
                              Number(value.target.value)
                            );
                            setSelectedMahalleKodu(Number(value.target.value));
                            formikProps.setFieldValue("caddeSokakKodu", null);
                          }}
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {mahalleListe.map((option) => (
                            <MenuItem
                              key={option.mahalleKodu}
                              value={option.mahalleKodu}
                            >
                              {option.mahalleAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="caddeSokakKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="caddeSokakKodu"
                          fullWidth
                          className="mb-3"
                          size="small"
                          error={
                            formikProps.errors.caddeSokakKodu &&
                              formikProps.touched.caddeSokakKodu
                              ? true
                              : false
                          }
                          select
                          label={getFieldLabel("caddeSokakKodu", "Cadde/Sokak *")}
                          value={formikProps.values.caddeSokakKodu}
                          onChange={(value: any) =>
                            formikProps.setFieldValue(
                              "caddeSokakKodu",
                              Number(value.target.value)
                            )
                          }
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {caddeListe.map((option) => (
                            <MenuItem
                              key={option.caddeSokakKodu}
                              value={option.caddeSokakKodu}
                            >
                              {option.caddeSokakAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="kapiNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          name="kapiNo"
                          className="mb-3"
                          size="small"
                          error={
                            formikProps.errors.kapiNo &&
                              formikProps.touched.kapiNo
                              ? true
                              : false
                          }
                          label={getFieldLabel("kapiNo", "Kapı No *")}
                          value={formikProps.values.kapiNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("kapiNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : "")
                          }

                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="altKapiNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("altKapiNo", "Alt Kapı No")}
                          error={
                            formikProps.errors.altKapiNo &&
                              formikProps.touched.altKapiNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("altKapiNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="daireNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("daireNo", "Daire No")}
                          error={
                            formikProps.errors.daireNo &&
                              formikProps.touched.daireNo
                              ? true
                              : false
                          }
                          value={formikProps.values.daireNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("daireNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : "")
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="altDaireNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("altDaireNo", "Alt Daire No")}
                          error={
                            formikProps.errors.altDaireNo &&
                              formikProps.touched.altDaireNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("altDaireNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <ConfigurableField fieldName="siteApartmanAdi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                    <div className="row">
                      <div className="col-12">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("siteApartmanAdi", "Site/Apartman Adı")}
                          error={
                            formikProps.errors.siteApartmanAdi &&
                              formikProps.touched.siteApartmanAdi
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("siteApartmanAdi")}
                          variant="outlined"
                        />
                      </div>
                    </div>
                    </ConfigurableField>
                    <div className="row">
                      <ConfigurableField fieldName="blokNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("blokNo", "Blok No")}
                          error={
                            formikProps.errors.blokNo &&
                              formikProps.touched.blokNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("blokNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="katNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("katNo", "Kat No")}
                          error={
                            formikProps.errors.katNo &&
                              formikProps.touched.katNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("katNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="pafta" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("pafta", "Pafta *")}
                          error={
                            formikProps.errors.pafta &&
                              formikProps.touched.pafta
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("pafta")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="ada" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <CustomTextField
                          name="ada"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("ada", "Ada *")}
                          error={
                            formikProps.errors.ada && formikProps.touched.ada
                              ? true
                              : false
                          }
                          value={formikProps.values.ada}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("ada", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 10) : "")
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="parsel" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <CustomTextField
                          name="parsel"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("parsel", "Parsel *")}
                          error={
                            formikProps.errors.parsel &&
                              formikProps.touched.parsel
                              ? true
                              : false
                          }
                          value={formikProps.values.parsel}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("parsel", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 10) : "")
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="tapuBlokNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("tapuBlokNo", "Tapu Blok No")}
                          error={
                            formikProps.errors.tapuBlokNo &&
                              formikProps.touched.tapuBlokNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("tapuBlokNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="tapuKatNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("tapuKatNo", "Tapu Kat No")}
                          error={
                            formikProps.errors.tapuKatNo &&
                              formikProps.touched.tapuKatNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("tapuKatNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="tapuCiltNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("tapuCiltNo", "Tapu Cilt No")}
                          error={
                            formikProps.errors.tapuCiltNo &&
                              formikProps.touched.tapuCiltNo
                              ? true
                              : false
                          }
                          value={formikProps.values.tapuCiltNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("tapuCiltNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 7) : "")
                          }

                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="tapuSayfaNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4 mb-3 mb-lg-0">
                        <TextField
                          fullWidth
                          size="small"
                          error={
                            formikProps.errors.tapuSayfaNo &&
                              formikProps.touched.tapuSayfaNo
                              ? true
                              : false
                          }
                          label={getFieldLabel("tapuSayfaNo", "Tapu Sayfa No")}
                          value={formikProps.values.tapuSayfaNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("tapuSayfaNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 7) : "")
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="tapuYevmiyeNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4 mb-3 mb-lg-0">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("tapuYevmiyeNo", "Tapu Yevmiye No")}
                          error={
                            formikProps.errors.tapuYevmiyeNo &&
                              formikProps.touched.tapuYevmiyeNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("tapuYevmiyeNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="tapuBagimsizNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4 mb-3 mb-lg-0">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("tapuBagimsizNo", "Tapu Bağımsız No")}
                          error={
                            formikProps.errors.tapuBagimsizNo &&
                              formikProps.touched.tapuBagimsizNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("tapuBagimsizNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="tapuYevmiyeTarihi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <DatePicker
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error:
                                formikProps.errors.tapuYevmiyeTarihi &&
                                  formikProps.touched.tapuYevmiyeTarihi
                                  ? true
                                  : false,
                            },
                          }}
                          label={getFieldLabel("tapuYevmiyeTarihi", "Tapu Yevmiye Tarihi")}
                          value={formikProps.values.tapuYevmiyeTarihi}
                          onChange={(value) =>
                            formikProps.setFieldValue(
                              "tapuYevmiyeTarihi",
                              value
                            )
                          }
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <ConfigurableField fieldName="arsaYuzolcumu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="arsaYuzolcumu"
                          fullWidth
                          className="mb-3"
                          size="small"
                          error={
                            formikProps.errors.arsaYuzolcumu &&
                              formikProps.touched.arsaYuzolcumu
                              ? true
                              : false
                          }
                          label={getFieldLabel("arsaYuzolcumu", "Arsa Yüz Ölçümü *")}
                          value={formikProps.values.arsaYuzolcumu}
                          onChange={(e: any) =>
                            handleDecimalChange("arsaYuzolcumu", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arsaYuzolcumu", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="arsaHisse" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="arsaHisse"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("arsaHisse", "Arsa Hisse *")}
                          error={
                            formikProps.errors.arsaHisse &&
                              formikProps.touched.arsaHisse
                              ? true
                              : false
                          }
                          value={formikProps.values.arsaHisse}
                          onChange={(e: any) =>
                            handleDecimalChange("arsaHisse", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arsaHisse", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="arsaOran" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="arsaOran"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("arsaOran", "Arsa Oran *")}
                          error={
                            formikProps.errors.arsaOran &&
                              formikProps.touched.arsaOran
                              ? true
                              : false
                          }
                          value={formikProps.values.arsaOran}
                          onChange={(e: any) =>
                            handleDecimalChange("arsaOran", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arsaOran", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="arsa2Hisse" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("arsa2Hisse", "Arsa 2 Hisse *")}
                          error={
                            formikProps.errors.arsa2Hisse &&
                              formikProps.touched.arsa2Hisse
                              ? true
                              : false
                          }
                          value={formikProps.values.arsa2Hisse || "1.00"}
                          onChange={(e: any) =>
                            handleDecimalChange("arsa2Hisse", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arsa2Hisse", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="arsa2Oran" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("arsa2Oran", "Arsa 2. Oran *")}
                          error={
                            formikProps.errors.arsa2Oran &&
                              formikProps.touched.arsa2Oran
                              ? true
                              : false
                          }
                          value={formikProps.values.arsa2Oran || "1.00"}
                          onChange={(e: any) =>
                            handleDecimalChange("arsa2Oran", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arsa2Oran", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="hisseyeDusenArsaYuzolcumu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("hisseyeDusenArsaYuzolcumu", "Hisseye Düşen Arsa Yüz Ölcümü")}
                          error={
                            formikProps.errors.hisseyeDusenArsaYuzolcumu &&
                              formikProps.touched.hisseyeDusenArsaYuzolcumu
                              ? true
                              : false
                          }
                          disabled={true}
                          {...formikProps.getFieldProps(
                            "hisseyeDusenArsaYuzolcumu"
                          )}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="binaYuzolcumu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="binaYuzolcumu"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("binaYuzolcumu", "Bina Yüz Ölçümü *")}
                          error={
                            formikProps.errors.binaYuzolcumu &&
                              formikProps.touched.binaYuzolcumu
                              ? true
                              : false
                          }
                          value={formikProps.values.binaYuzolcumu}
                          onChange={(e: any) =>
                            handleDecimalChange("binaYuzolcumu", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("binaYuzolcumu", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="binaHisse" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="binaHisse"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("binaHisse", "Bina Hisse *")}
                          error={
                            formikProps.errors.binaHisse &&
                              formikProps.touched.binaHisse
                              ? true
                              : false
                          }
                          value={formikProps.values.binaHisse}
                          onChange={(e: any) =>
                            handleDecimalChange("binaHisse", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("binaHisse", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="binaOran" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="binaOran"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("binaOran", "Bina Oran *")}
                          error={
                            formikProps.errors.binaOran &&
                              formikProps.touched.binaOran
                              ? true
                              : false
                          }
                          value={formikProps.values.binaOran}
                          onChange={(e: any) =>
                            handleDecimalChange("binaOran", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("binaOran", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="bina2Hisse" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("bina2Hisse", "Bina 2. Hisse")}
                          error={
                            formikProps.errors.bina2Hisse &&
                              formikProps.touched.bina2Hisse
                              ? true
                              : false
                          }
                          value={formikProps.values.bina2Hisse || "1.00"}
                          onChange={(e: any) =>
                            handleDecimalChange("bina2Hisse", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("bina2Hisse", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="bina2Oran" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          label={getFieldLabel("bina2Oran", "Bina 2. Oran")}
                          error={
                            formikProps.errors.bina2Oran &&
                              formikProps.touched.bina2Oran
                              ? true
                              : false
                          }
                          value={formikProps.values.bina2Oran || "1.00"}
                          onChange={(e: any) =>
                            handleDecimalChange("bina2Oran", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("bina2Oran", e.target.value, formikProps.setFieldValue)
                          }
                          size="small"
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="hisseyeDusenBinaYuzolcumu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          error={
                            formikProps.errors.hisseyeDusenBinaYuzolcumu &&
                              formikProps.touched.hisseyeDusenBinaYuzolcumu
                              ? true
                              : false
                          }
                          disabled={true}
                          label={getFieldLabel("hisseyeDusenBinaYuzolcumu", "Hisseye Düşen Bina Yüzölçümü")}
                          {...formikProps.getFieldProps(
                            "hisseyeDusenBinaYuzolcumu"
                          )}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="pismanlikIndirimi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          select
                          error={
                            formikProps.errors.pismanlikIndirimi &&
                              formikProps.touched.pismanlikIndirimi
                              ? true
                              : false
                          }
                          label={getFieldLabel("pismanlikIndirimi", "Pişmanlık İndirimi")}
                          {...formikProps.getFieldProps("pismanlikIndirimi")}
                          size="small"
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          <MenuItem selected value={"E"}>
                            {"Evet"}
                          </MenuItem>
                          <MenuItem selected value={"H"}>
                            {"Hayır"}
                          </MenuItem>
                        </TextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="insaatTuruKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          select
                          label={getFieldLabel("insaatTuruKodu", "İnşaat Türü")}
                          error={
                            formikProps.errors.insaatTuruKodu &&
                              formikProps.touched.insaatTuruKodu
                              ? true
                              : false
                          }
                          value={formikProps.values.insaatTuruKodu || ""}
                          onChange={(e) =>
                            formikProps.setFieldValue(
                              "insaatTuruKodu",
                              e.target.value
                            )
                          }
                        >
                          <MenuItem value={""}>{"Seçiniz.."}</MenuItem>
                          {insaatTuruKoduList.map((option) => (
                            <MenuItem
                              key={option.insaatTuruKodu}
                              value={option.insaatTuruKodu}
                            >
                              {option.insaatTuruAdi}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="insaatSinifiKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6 mb-3 mb-lg-0">
                        <TextField
                          fullWidth
                          select
                          label={getFieldLabel("insaatSinifiKodu", "İnşaat Sınıfı")}
                          error={
                            formikProps.errors.insaatSinifiKodu &&
                              formikProps.touched.insaatSinifiKodu
                              ? true
                              : false
                          }
                          value={formikProps.values.insaatSinifiKodu || ""}
                          onChange={(e) =>
                            formikProps.setFieldValue(
                              "insaatSinifiKodu",
                              e.target.value
                            )
                          }
                          size="small"
                        >
                          <MenuItem value={""}>{"Seçiniz.."}</MenuItem>
                          {insaatSinifiKoduList.map((option) => (
                            <MenuItem
                              key={option.insaatSinifiKodu}
                              value={option.insaatSinifiKodu}
                            >
                              {option.insaatSinifiAdi}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="kullanimSekliKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6 ">
                        <CustomTextField
                          fullWidth
                          name="kullanimSekliKodu"
                          size="small"
                          select
                          label={getFieldLabel("kullanimSekliKodu", "Kullanım Şekli *")}
                          error={
                            formikProps.errors.kullanimSekliKodu &&
                              formikProps.touched.kullanimSekliKodu
                              ? true
                              : false
                          }
                          value={formikProps.values.kullanimSekliKodu || ""}
                          onChange={(e: any) =>
                            formikProps.setFieldValue(
                              "kullanimSekliKodu",
                              e.target.value
                            )
                          }
                        >
                          <MenuItem value={""}>{"Seçiniz.."}</MenuItem>
                          {kullanimSekliKoduList.map((option, number) => (
                            <MenuItem
                              key={number}
                              value={option.kullanimSekliKodu}
                            >
                              {option.kullanimSekliAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-sm-2 mt-xxl-0 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12"></div>
                      <ConfigurableField fieldName="insaatBitisTarihi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomDatePicker
                          name="insaatBitisTarihi"
                          slotProps={{
                            textField: {
                              size: "small", fullWidth: true, error:
                                formikProps.errors.insaatBitisTarihi &&
                                  formikProps.touched.insaatBitisTarihi
                                  ? true
                                  : false,
                            },
                          }}
                          label={getFieldLabel("insaatBitisTarihi", "İnsaat Bitiş Tarihi *")}
                          value={formikProps.values.insaatBitisTarihi}
                          onChange={(value: any) =>
                            formikProps.setFieldValue(
                              "insaatBitisTarihi",
                              value
                            )
                          }
                          className="mb-3"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="edinmeTarihi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomDatePicker
                          name="edinmeTarihi"
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error:
                                formikProps.errors.edinmeTarihi &&
                                  formikProps.touched.edinmeTarihi
                                  ? true
                                  : false,
                            },
                          }}
                          label={getFieldLabel("edinmeTarihi", "Edinme Tarihi *")}
                          value={formikProps.values.edinmeTarihi}
                          onChange={(value: any) =>
                            formikProps.setFieldValue("edinmeTarihi", value)
                          }
                          className="mb-3"
                        />
                      </div>
                      </ConfigurableField>
                      <div className="row w-100 m-0 mb-3">
                        <ConfigurableField fieldName="kaloriferliMi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                        <div className="col-lg-6 p-0 px-lg-2 ps-lg-0 mb-3 mb-lg-0">
                          <div className="card w-100">
                            <div className="card-body w-100">
                              <h6
                                style={
                                  formikProps.errors.kaloriferliMi &&
                                    formikProps.touched.kaloriferliMi
                                    ? { color: "red" }
                                    : undefined
                                }
                              >
                                {getFieldLabel("kaloriferliMi", "Kaloriferli mi?")}<span style={{ color: 'red' }}>*</span>
                              </h6>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                {...formikProps.getFieldProps("kaloriferliMi")}
                                row={true}
                                defaultValue={formikProps.values.kaloriferliMi}
                              >
                                <FormControlLabel
                                  value="E"
                                  control={<Radio />}
                                  style={
                                    formikProps.errors.kaloriferliMi &&
                                      formikProps.touched.kaloriferliMi
                                      ? { color: "red" }
                                      : undefined
                                  }
                                  label="Evet"
                                />
                                <FormControlLabel
                                  value="H"
                                  control={<Radio />}
                                  style={
                                    formikProps.errors.kaloriferliMi &&
                                      formikProps.touched.kaloriferliMi
                                      ? { color: "red" }
                                      : undefined
                                  }
                                  label="Hayır"
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>
                        </ConfigurableField>
                        <ConfigurableField fieldName="asansorluMu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                        <div className="col-lg-6 p-0 px-lg-2 pe-lg-0">
                          <div className="card w-100">
                            <div className="card-body w-100">
                              <h6
                                style={
                                  formikProps.errors.asansorluMu &&
                                    formikProps.touched.asansorluMu
                                    ? { color: "red" }
                                    : undefined
                                }
                              >
                                {getFieldLabel("asansorluMu", "Asansörlü mü?")}<span style={{ color: 'red' }}>*</span>
                              </h6>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                {...formikProps.getFieldProps("asansorluMu")}
                                row={true}
                                defaultValue={formikProps.values.asansorluMu}
                              >
                                <FormControlLabel
                                  value="E"
                                  control={<Radio />}
                                  style={
                                    formikProps.errors.asansorluMu &&
                                      formikProps.touched.asansorluMu
                                      ? { color: "red" }
                                      : undefined
                                  }
                                  label="Evet"
                                />
                                <FormControlLabel
                                  value="H"
                                  control={<Radio />}
                                  style={
                                    formikProps.errors.asansorluMu &&
                                      formikProps.touched.asansorluMu
                                      ? { color: "red" }
                                      : undefined
                                  }
                                  label="Hayır"
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>
                        </ConfigurableField>
                      </div>
                      <ConfigurableField fieldName="aciklama" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="row pe-0">
                        <div className="col-12 pe-0">
                          <TextField
                            id="outlined-multiline-flexible"
                            label={getFieldLabel("aciklama", "Açıklama")}
                            error={
                              formikProps.errors.aciklama &&
                                formikProps.touched.aciklama
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("aciklama")}
                            rows={10.1}
                            fullWidth
                            multiline
                            maxRows={10}
                          />
                        </div>
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div ref={documentTableRef}>
                {!docsLoaded ? (
                  <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                ) : (
                  <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                )}
              </div>
              <div className="col-12 mt-2">
                <div className="d-flex justify-content-end align-self-stretch">
                  <Recaptcha
                    ref={recaptchaRef}
                    changeHandleRecaptcha={setRecaptchaPassed}
                  />
                  <Button
                    onClick={() => showToastIfErrorsExist()}
                    type="submit"

                  >
                    Gönder
                  </Button>
                  {loadingSubmit && (
                    <div
                      style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(255,255,255,0.6)",
                        zIndex: 1300,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  )}
                </div>
              </div>
              {open ? (
                <GayrimenkulBulPopUp
                  onSelectEmlak={(emlak: any) => {
                    if (emlak) {
                      formikProps.setFieldValue("pafta", emlak.pafta);
                      formikProps.setFieldValue("ada", emlak.ada);
                      formikProps.setFieldValue("parsel", emlak.parsel);
                      formikProps.setFieldValue(
                        "mahalleKodu",
                        emlak.mahalleKodu
                      );
                      setSelectedMahalleKodu(emlak.mahalleKodu);
                      formikProps.setFieldValue(
                        "caddeSokakKodu",
                        emlak.caddeSokakKodu
                      );
                      formikProps.setFieldValue(
                        "tapuBagimsizNo",
                        emlak.tapuBagimsizNo
                      );
                      formikProps.setFieldValue("kapiNo", emlak.kapiNo);
                      closePopup();
                    }
                  }}
                  open={open}
                  onClose={setOpen}
                  type="1"
                />
              ) : null}
              {isPopupVisible ? (
                <BilgilendirmePopup
                  basvuruTuruId={formikProps.values.basvuruTuruId}
                  isSorunBildirPopup={!kayitBasarili}
                  closePopup={closePopupSonuc}
                  open={isPopupVisible}
                  editDescription={popupAciklama}
                />
              ) : null}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default BinaBasvuru;